import React from 'react'
import styles from './index.module.css'
import {Link} from 'react-router-dom'
import moment from 'moment'

const Index = ({item, setModal}) => {
    return (
        <div className={styles.wrapper} key={item.id} onClick={() => setModal(item)}>
            <div>
                <div className={styles.date}>{moment(item.date).format('DD.MM.YYYY')}</div>
                <div className={styles.title}>{item.title}</div>
                <div className={styles.text}>{item.text}</div>
                {item.tags
                    ? <div className={styles.tags}>
                            {item
                                .tags
                                .map(tag => <div className={styles.tag} key={tag}>#{tag}</div>)
}
                        </div>
                    : null
}
            </div>
        </div>
    )
}

export default Index